import { Component, computed, input } from '@angular/core';
import { Status, type AsyncState } from '@essent/common';

/**
 * This component represents the submit state of the given input
 */
@Component({
  selector: 'rfa-submit',
  templateUrl: './rfa-submit.component.html',
})
export class RfaSubmitComponent {
  public readonly submitState = input.required<AsyncState<unknown>>();
  public readonly automationId = input<string>();
  public readonly showLoaderOnSubmit = input(true);

  protected readonly buttonState = computed(() => {
    if (this.submitState().status === Status.SUCCESS) {
      return 'success';
    }
    if (
      this.showLoaderOnSubmit() &&
      this.submitState().status === Status.PENDING
    ) {
      return 'processing';
    }
    return 'enabled';
  });
}
